import eventBus, { SHOW_MESSAGE } from '@/util/eventBus';

export function getValidationErrorMap(errors, allowedKeys = [], requestKey = '') {
  const map = {};
  const allowedKeyMap = {};
  allowedKeys.forEach((key) => {
    allowedKeyMap[key] = true;
  });
  errors.forEach((error) => {
    if (error.field && allowedKeyMap[error.field]) {
      map[error.field] = error.message;
    } else if (error.field) {
      eventBus.$emit(SHOW_MESSAGE, {
        key: error.field,
        requestKey,
        type: 'error',
        text: error.message,
      });
    }
  });
  return map;
}
